<template>
    <ListingWrapperLoadingState v-if="loading" />
    <div v-else class="listing-wrapper">
        <div v-if="title" class="listing-wrapper__header">
            <div>
                <h1 class="typographies-heading-h1">{{ title }}</h1>
                <TabsNav
                    v-if="!!tabs.length"
                    :tabs="tabs"
                    :activeTab="activeTab"
                    @tab-clicked="(tab) => $emit('update:activeTab', tab)"
                />
            </div>
            <div class="listing-wrapper__header-actions">
                <slot name="listingActions" />
            </div>
        </div>
        <!-- ACTIONS -->
        <div class="listing-wrapper-settings-header__container">
            <Paginator
                v-if="!!pagination"
                class="listing-wrapper-settings-header__pagination"
                :pagination="pagination"
                @pagination:update="updatePaginationOffset"
            />

            <!-- FILTRES -->
            <slot name="settings" />
        </div>

        <slot name="table" />
    </div>
</template>

<script>
import Paginator from 'vcomponents/utilities/Paginator.vue';
import TabsNav from 'vcomponents/utilities/TabsNav.vue';
import ListingWrapperLoadingState from 'vcomponents/common/listing/ListingWrapperLoadingState.vue';
export default {
    components: {
        TabsNav,
        Paginator,
        ListingWrapperLoadingState,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        tabs: {
            type: Array,
            default: () => [],
        },
        activeTab: {
            type: String,
            default: '',
        },
        pagination: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            iteratorKey: 0,
            params: {
                limit: 25,
                offset: 0,
            },
        };
    },
    created() {
        if (this.pagination) {
            this.params.limit = this.pagination.per_page;
            this.params.offset = this.getPaginationOffset({
                currentPage: this.pagination.current_page,
                paginationLimit: this.pagination.per_page,
            });
        }
    },
    methods: {
        updatePaginationOffset(newPage) {
            this.params.offset = this.getPaginationOffset({
                currentPage: newPage,
                paginationLimit: this.params.limit,
            });
            this.updatePagination();
        },
        updatePagination() {
            this.$emit('update-pagination', this.params);
        },
        getPaginationOffset({ currentPage, paginationLimit }) {
            return (this.params.offset = (currentPage - 1) * paginationLimit);
        },
    },
};
</script>

<style lang="scss" scoped>
.listing-wrapper {
    padding-bottom: var(--spacing-4);
    &__header {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: var(--spacing-4);

        h1 {
            margin: 0;
        }

        & > div:first-child {
            align-items: center;
            display: flex;
            flex-direction: row;
            gap: var(--spacing-4);

            .title,
            .tabs-list {
                margin: 0;
            }
        }

        &-actions {
            display: flex;
            gap: var(--spacing-1);
        }
    }

    &-settings-header {
        &__container {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-4);
        }

        &__pagination {
            align-self: flex-end;
        }
    }

    &:has(.listing-settings-header) {
        &::v-deep {
            .compass-table {
                border-top-left-radius: 0;
                border-top-right-radius: 0;
            }
        }
    }
}
</style>
